module.exports = __webpack_public_path__ + "img/ale.0950514a.png";